import { render, staticRenderFns } from "./WithdrawManagementScreen.vue?vue&type=template&id=57e81854&scoped=true&"
import script from "./WithdrawManagementScreen.vue?vue&type=script&lang=js&"
export * from "./WithdrawManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e81854",
  null
  
)

export default component.exports